export type StripePaymentMethodType = 'card' | 'klarna' | 'ideal'

export const STRIPE_PAYMENT_METHOD_ORDER: StripePaymentMethodType[] = ['card', 'klarna', 'ideal']

export const KLARNA_PAYMENT_METHOD_TYPE: StripePaymentMethodType = 'klarna'

export const REDIRECT_PAYMENT_METHOD_TYPES: StripePaymentMethodType[] = ['klarna', 'ideal']

export function isRedirectPaymentMethod(type: StripePaymentMethodType): boolean {
  return REDIRECT_PAYMENT_METHOD_TYPES.includes(type)
}
